<template>
  <div>
    <v-dialog
      v-show="changePasswordDialog"
      v-model="changePasswordDialog"
      persistent
      max-width="600px"
      v-scroll-lock="!changePasswordDialog"
    >
      <v-card>
        <v-card-title class="headline justify-center">
          <span class="mt-3">
            Change Password
          </span>
          <v-spacer></v-spacer>
          <v-col class="text-right body-1">
            <span class="error--text">*</span>
            is required.
          </v-col>
        </v-card-title>
        <v-list-item class="px-6">
          <v-list-item-content class="mt-3 px-3">
            <v-row v-if="updateCompleted">
              <v-col cols="12">
                <v-alert type="success">
                  Password has been updated.
                </v-alert>
              </v-col>
            </v-row>
            <!-- Old Password -->
            <v-row dense>
              <v-col cols="4" class="pt-4">
                Old Password
                <span class="error--text">*</span>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  name="old-password"
                  v-model="oldPassword.value"
                  :append-icon="oldPassword.show ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="oldPassword.show ? 'text' : 'password'"
                  outlined
                  dense
                  placeholder="Old Password"
                  @click:append="oldPassword.show = !oldPassword.show"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- New Password -->
            <v-row dense>
              <v-col cols="4" class="pt-4">
                New Password
                <span class="error--text">*</span>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  name="new-password"
                  v-model="newPassword.value"
                  :append-icon="newPassword.show ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="newPassword.show ? 'text' : 'password'"
                  outlined
                  dense
                  placeholder="New Password"
                  @click:append="newPassword.show = !newPassword.show"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Confirm Password -->
            <v-row dense>
              <v-col cols="4" class="pt-4">
                Confirm Password
                <span class="error--text">*</span>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  name="confirm-password"
                  v-model="confirmPassword.value"
                  :append-icon="
                    confirmPassword.show ? 'mdi-eye' : 'mdi-eye-off'
                  "
                  :type="confirmPassword.show ? 'text' : 'password'"
                  outlined
                  dense
                  placeholder="Confirm Password"
                  @click:append="confirmPassword.show = !confirmPassword.show"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- error message -->
            <v-row v-if="errorMessage">
              <v-col>
                <span class="error--text">{{ errorMessage }}</span>
              </v-col>
            </v-row>
            <!-- update -->
            <v-row dense>
              <v-col cols="4" class="pt-4"></v-col>
              <v-col cols="8" style="text-align: right;">
                <v-btn
                  name="update"
                  color="primary"
                  v-if="canChangePassword"
                  @click="update()"
                >
                  update
                </v-btn>
                <v-btn color="disabled" disabled v-else>update</v-btn>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>

        <v-row class="mt-8" style="margin-left: 30px;">
          <v-btn
            class="mb-5"
            color="error"
            @click="setChangePasswordDialog(false)"
          >
            Close
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {Auth} from 'aws-amplify'

export default {
  name: 'ChangePasswordDialog',
  props: {
    changePasswordDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      oldPassword: {
        show: false,
        value: null,
      },
      newPassword: {
        show: false,
        value: null,
      },
      confirmPassword: {
        show: false,
        value: null,
      },
      errorMessage: null,
      updateCompleted: false,
    }
  },
  computed: {
    canChangePassword: function() {
      return (
        this.oldPassword.value &&
        this.newPassword.value &&
        this.confirmPassword.value
      )
    },
  },
  methods: {
    setChangePasswordDialog(show) {
      if (!show) {
        this.updateCompleted = false
      }
      this.$emit('setChangePasswordDialog', show)
    },
    update() {
      this.updateCompleted = false
      if (this.newPassword.value !== this.confirmPassword.value) {
        this.errorMessage =
          'New Password and Confirm Password values must match.'
        return false
      }
      if (
        this.newPassword.value.length < 7 ||
        this.oldPassword.value.length < 7
      ) {
        this.errorMessage = 'Password not long enough'
        return false
      }
      Auth.currentAuthenticatedUser()
        .then((user) => {
          return Auth.changePassword(
            user,
            this.oldPassword.value,
            this.newPassword.value
          )
        })
        .then((data) => {
          this.errorMessage = null
          this.oldPassword.value = null
          this.newPassword.value = null
          this.confirmPassword.value = null
          this.updateCompleted = true
        })
        .catch((err) => {
          if (err.message === 'Incorrect username or password.') {
            this.errorMessage = 'Incorrect old password.'
            return
          }
          this.errorMessage = err.message
        })
    },
  },
  mounted() {},
}
</script>

<style></style>
